import { Attachment } from "@relode/core";
import * as domain from "@relode/core/domain";
import { Location } from "@relode/core/domain";
import { AddJobStep3Details } from "../../../shared/types";

export class AddJobSteps {
    stepOne: {
        teamId: number;
        externalDescription: string;
        isIntegrated: boolean;
        attachment: Attachment;
        hasActiveTeamPlan: boolean;
        jobConcurrencyToken: string;
    };
    stepTwo: {
        jobName: string;
        teamId: number;
        location: Location;
        normalizedJobName: string;
        normalizedLocation: Location;
        quantity: number;
        jobTypeId: number;
        hoursPerWeek: number;
        jobSalaryInUSDollars: number;
        jobSalaryTypeId: number;
        contractStartDate: Date;
        contractDuration: number;
        contractDurationTypeId: number;
        jobConcurrencyToken: string;
    };
    stepThree: AddJobStep3Details;

    private constructor() {
        this.stepOne = {
            teamId: undefined,
            externalDescription: undefined,
            isIntegrated: undefined,
            attachment: undefined,
            hasActiveTeamPlan: undefined,
            jobConcurrencyToken: undefined,
        };
        this.stepTwo = {
            jobName: undefined,
            teamId: undefined,
            location: undefined,
            normalizedJobName: undefined,
            normalizedLocation: undefined,
            quantity: 1,
            jobTypeId: domain.JobType.FullTime.jobTypeId,
            hoursPerWeek: 40,
            jobSalaryInUSDollars: undefined,
            jobSalaryTypeId: undefined,
            contractStartDate: undefined,
            contractDuration: undefined,
            contractDurationTypeId: undefined,
            jobConcurrencyToken: undefined,
        };
        this.stepThree = {
            jobId: undefined,
            jobLocationName: undefined,
            jobPriorityType: undefined,
            planName: undefined,
            postingFeeInUSDollars: undefined,
            successFeePercentage: undefined,
            successFeeInUSDollars: undefined,
            successFeeSavingsInUSDollars: undefined,
            employmentGuarantee: undefined,
            quantity: undefined,
            defaultPostingFeeInUSDollars: undefined,
            marketResearchFeatureType: undefined,
            defaultJobPriorityASuccessFeePercentage: undefined,
            defaultJobPriorityBSuccessFeePercentage: undefined,
            defaultJobPriorityCSuccessFeePercentage: undefined,
            defaultJobPriorityDSuccessFeePercentage: undefined,
            estimatedDefaultJobPriorityASuccessFeeInUSDollars: undefined,
            estimatedDefaultJobPriorityBSuccessFeeInUSDollars: undefined,
            estimatedDefaultJobPriorityCSuccessFeeInUSDollars: undefined,
            estimatedDefaultJobPriorityDSuccessFeeInUSDollars: undefined,
            estimatedDefaultJobPriorityASuccessFeeSavingsInUSDollars: undefined,
            estimatedDefaultJobPriorityBSuccessFeeSavingsInUSDollars: undefined,
            estimatedDefaultJobPriorityCSuccessFeeSavingsInUSDollars: undefined,
            estimatedDefaultJobPriorityDSuccessFeeSavingsInUSDollars: undefined,
            jobManagerFullName: undefined,
            jobManagerRoleType: undefined,
            jobManagerUserId: undefined,
            jobConcurrencyToken: undefined,
            billRateInUSDollars: undefined,
            estimatedContractBillTotalInUSDollars: undefined,
            estimatedContractBillTotalSavingsInUSDollars: undefined,
            hasSignedAgreement: undefined,
            jobSalaryInUSDollars: undefined,
            contractStartDate: undefined,
            contractEndDate: undefined,
            hoursPerWeek: undefined,
        };
    }

    static create() {
        const result = new AddJobSteps();
        return result;
    }
}
